import { render, staticRenderFns } from "./DetailInternalStock.vue?vue&type=template&id=b5d5a7e0"
import script from "./DetailInternalStock.vue?vue&type=script&lang=js"
export * from "./DetailInternalStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports